import { render, staticRenderFns } from "./Navbox.vue?vue&type=template&id=379c342e&scoped=true"
import script from "./Navbox.vue?vue&type=script&lang=js"
export * from "./Navbox.vue?vue&type=script&lang=js"
import style0 from "./Navbox.vue?vue&type=style&index=0&id=379c342e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379c342e",
  null
  
)

export default component.exports